export default __webpack_public_path__ + "static/media/cb_2.c43a1163.png";